import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"inner-banner\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"banner-content text-center\"><h1>Job Category</h1><span></span></div></div></div></div></div>", 1)
const _hoisted_2 = { class: "category-listing-area pt-120 mb-120" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row g-lg-4" }
const _hoisted_5 = { class: "col-lg-12" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"row g-4 mb-25\"><div class=\"col-md-6 d-flex align-items-center\"><p class=\"show-item\">Showing results 10 in 200 jobs list</p></div><div class=\"col-md-6 d-flex align-items-center justify-content-md-end\"><form><div class=\"form-inner\"><input type=\"text\" placeholder=\"Search..\"><button class=\"primry-btn-2\" type=\"submit\"><img src=\"assets/images/icon/search-category.svg\" alt=\"\"></button></div></form></div></div>", 1)
const _hoisted_7 = { class: "row row-cols-xxl-5 row-cols-xl-4 row-cols-md-3 row-cols-sm-2 row-cols-1 g-3 cf justify-content-center mb-70" }
const _hoisted_8 = { class: "single-category" }
const _hoisted_9 = { class: "category-top" }
const _hoisted_10 = { class: "icon" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "sl-no" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "01")
], -1)
const _hoisted_13 = { class: "category-content" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-lg-12 d-flex justify-content-center" }
const _hoisted_16 = { class: "pagination-area" }
const _hoisted_17 = { "aria-label": "..." }
const _hoisted_18 = { class: "pagination" }
const _hoisted_19 = { class: "page-item disabled" }
const _hoisted_20 = {
  class: "page-item active",
  "aria-current": "page"
}
const _hoisted_21 = { class: "page-item" }
const _hoisted_22 = { class: "page-item" }
const _hoisted_23 = { class: "page-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col",
                  key: category.id
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        (category.image)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: (category.image),
                              width: "24",
                              height: "24",
                              alt: ""
                            }, null, 8, _hoisted_11))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_12
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("h5", null, [
                        _createVNode(_component_router_link, { to: "/job-listing" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(category.name), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("p", null, [
                        _createTextVNode("Job Available: "),
                        _createElementVNode("span", null, _toDisplayString(category.cat_counts), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("nav", _hoisted_17, [
                    _createElementVNode("ul", _hoisted_18, [
                      _createElementVNode("li", _hoisted_19, [
                        _createVNode(_component_router_link, {
                          class: "page-link",
                          to: "#",
                          tabindex: "-1"
                        })
                      ]),
                      _createElementVNode("li", _hoisted_20, [
                        _createVNode(_component_router_link, {
                          class: "page-link",
                          to: "#"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("01")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_21, [
                        _createVNode(_component_router_link, {
                          class: "page-link",
                          to: "#"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("02")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_22, [
                        _createVNode(_component_router_link, {
                          class: "page-link",
                          to: "#"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("03")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_23, [
                        _createVNode(_component_router_link, {
                          class: "page-link",
                          to: "#"
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}